// Module
var code = "<h3>History Log</h3> <div class=\"card\"> <table id=\"appHistoryTable\" class=\"w-full my-5\"></table> </div> ";
// Exports
export default code;